// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T565","clinicsSelect":"styles_clinicsSelect__2htE_"};